import { Calendar, Ticket, Search, Inbox, WifiOff, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Generic empty state component
export function EmptyState({ 
  icon: Icon = Inbox, 
  title, 
  description, 
  action,
  actionLabel,
  className = ''
}) {
  return (
    <div className={`empty-state ${className}`}>
      <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mb-4">
        <Icon className="empty-state-icon w-10 h-10" />
      </div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-description">{description}</p>
      {action && actionLabel && (
        <Button onClick={action} className="btn-press">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}

// No events found
export function NoEventsState({ onRefresh }) {
  return (
    <EmptyState
      icon={Calendar}
      title="No Events Found"
      description="There are no upcoming events at the moment. Check back soon for new matches and events!"
      action={onRefresh}
      actionLabel="Refresh"
    />
  );
}

// No tickets
export function NoTicketsState({ onBrowse }) {
  return (
    <EmptyState
      icon={Ticket}
      title="No Tickets Yet"
      description="You haven't purchased any tickets yet. Browse events to get your first ticket!"
      action={onBrowse}
      actionLabel="Browse Events"
    />
  );
}

// No search results
export function NoSearchResultsState({ query, onClear }) {
  return (
    <EmptyState
      icon={Search}
      title="No Results"
      description={`We couldn't find any events matching "${query}". Try a different search term.`}
      action={onClear}
      actionLabel="Clear Search"
    />
  );
}

// Network error state
export function NetworkErrorState({ onRetry }) {
  return (
    <EmptyState
      icon={WifiOff}
      title="Connection Error"
      description="Unable to connect to the server. Please check your internet connection and try again."
      action={onRetry}
      actionLabel="Try Again"
    />
  );
}

// Generic error state
export function ErrorState({ message, onRetry }) {
  return (
    <EmptyState
      icon={AlertCircle}
      title="Something Went Wrong"
      description={message || "An unexpected error occurred. Please try again."}
      action={onRetry}
      actionLabel="Try Again"
    />
  );
}

export default EmptyState;
